export default __webpack_public_path__ + "static/Needs-Assessment-63b116d376c50d2b364a0ea28d3c3361.webp";